import { PageTemplate, HeaderTemplate } from "../styles";
import { useLocation } from "react-router-dom";
import { getCustomerOrder } from "../api/order";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Refund } from "../styles";
import { convertDate } from "../utils";

const ReturnConfirmation = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber;
  const orderEmail = state?.orderEmail;

  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getCustomerOrder(orderNumber, orderEmail);
        setOrder(result);
      } catch (error) {
        console.error(error.message);
        toast.error(error.message);
      }
    };
    orderNumber && fetchData();
  }, []);

  let returnTotal = 0;

  const renderReturns = () => {
    return order.returns.map((returnObj) => {
      returnTotal = returnObj.refundAmount / 100 + returnTotal;
      return <Refund>{renderProducts(returnObj)}</Refund>;
    });
  };

  const renderProducts = (returnObj) => {
    const filteredProducts = returnObj.products.filter((product) => {
      return product.returnType !== "Keep";
    });
    const products = filteredProducts.map((product) => {
      return (
        <div className="product-row" key={product.itemId}>
          <div className="product-image">
            <picture>
              <source srcSet={product.thumbnail} type="image/avif" />
              <img src={product.thumbnail} width="140" />
            </picture>
          </div>
          <div className="product-block">
            <h2>{product.productName}</h2>

            <div className="product-block-row">
              <span className="product-block-label">Return Type</span>
              <strong className="product-block-value">{product.returnType}</strong>
            </div>
            <div className="product-block-row">
              <span className="product-block-label">Original Size</span>
              <strong className="product-block-value">{product.size}</strong>
            </div>
            <div className="product-block-row">
              {product.returnType === "Refund" ? (
                <>
                  <span className="product-block-label">Item Cost</span>
                  <strong className="product-block-value">${(product.productCost / 100).toFixed(2)}</strong>
                </>
              ) : (
                <>
                  <span className="product-block-label">Exchange Size</span>
                  <strong className="product-block-value">{product.sizeExchange}</strong>
                </>
              )}
            </div>
          </div>
        </div>
      );
    });
    return (
      <>
        <div className="refund-products">{products}</div>
        <div className="return-details">
          <div>
            Return Date
            <br />
            <span>{convertDate(returnObj.createdAt)}</span>
          </div>
          {returnObj.totalSalesTaxRefund > 0 && (
            <div>
              + Sales Tax Refund
              <br />
              <span>${(returnObj.totalSalesTaxRefund / 100).toFixed(2)}</span>
            </div>
          )}
          {returnObj.shippingFee > 0 && (
            <div>
              - Return Shipping Fee
              <br />
              <span>${(returnObj.shippingFee / 100).toFixed(2)}</span>
            </div>
          )}
          {returnObj.refundAmount > 0 && (
            <div>
              = Refund Amount
              <br />
              <span>${(returnObj.refundAmount / 100).toFixed(2)}</span>
            </div>
          )}
        </div>
      </>
    );
  };

  if (!orderNumber || !order) return null;

  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header no-line">
          <div className="title">
            <h1>Return Confirmation</h1>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        <div className="return-confirmation-title box-padding-2030">
          <h2>Order # {orderNumber}</h2>
          <p>Your return will be processed shortly. You will receive a return label via email within 24 hours.</p>
        </div>

        {renderReturns()}
        {returnTotal > 0 && (
          <>
            <div className="return-bottom-bar">
              <span className="text">Total Refund Amount for this Order</span>
              <span className="amount">${returnTotal.toFixed(2)}</span>
            </div>
            <p style={{ marginTop: "20px", fontStyle: "italic", padding: "0 20px", textAlign: "center" }}>
              <strong>1 Free Return Per Order</strong>
              <br />
              One free return allowed per order. Additional returns are subject to a shipping fee.
            </p>
          </>
        )}
      </PageTemplate>
    </>
  );
};

export default ReturnConfirmation;
